// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Y5ulT","header":"style__header__Qwc8N","content":"style__content__jDleE"};